import { getInterface } from '@/utils/js/initVariable';
export const getVerify = (data)=>{
  return getInterface.blobGet('api/AuthApi/getVerify', data);
}